$ = jQuery;
// Position Subscribe button inside of input
$(document).ready(function () {
	$('#gform_submit_button_1').appendTo('.gform_body');
});
// If there is validation error re-position Subscribe button inside of input
$(document).bind('gform_post_render', function(){
    $('#gform_submit_button_1').appendTo('.gform_body');
});